module.exports = __webpack_public_path__ + "static/img/COC2021-22.cbbf6f7.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/meeting/COC2021-22.jpg
// module id = DkTl
// module chunks = 0